import { AnimatePresence, LayoutGroup, motion } from 'framer-motion'
import React from 'react'
import { useKeyPressEvent } from 'react-use'
import styled from 'styled-components'
import { media } from 'utils/media'
import { ShowForDesktop, ShowForMobile } from 'lib/ShowComponent'
import { SearchContent } from 'modules/brands/list/components/SearchContent'
import { SearchInput } from 'modules/brands/list/components/SearchInput'
import { SearchModalMobile } from 'modules/brands/list/components/SearchModalMobile'
import { useAlgoliaSearchContext } from 'modules/brands/list/components/controllers/AlgoliaSearchContext'

const Modal = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  left: 25%;
  right: 25%;
  background-color: white;
  border-radius: 0px 0px 8px 8px;
  border: solid 1px var(--black-80);
  border-top: 0;
  z-index: 2000;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${media.tabletDown} {
    left: 78px;
    width: calc(100% - 156px);
    position: fixed;
  }

  ${media.phoneDown} {
    padding: 0 16px;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2000;
    border-radius: 0px;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;

  ${media.phoneDown} {
    justify-content: 'flex-start';
    min-height: 100vh;
  }
`

const InputContainer = styled.div`
  border-bottom: solid 1px var(--black-15);
  padding: 10px 16px;
`

const Background = styled(motion.div)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  background: #000;
  opacity: 0.2;
  z-index: 1999;

  ${media.phoneDown} {
    opacity: 0;
  }
`

const SearchContentNavbar = () => {
  const { handleArrowPress, handleEnterPress, closeModal } = useAlgoliaSearchContext()
  useKeyPressEvent('ArrowUp', handleArrowPress('increment'))
  useKeyPressEvent('ArrowDown', handleArrowPress('decrement'))
  useKeyPressEvent('Enter', handleEnterPress)
  useKeyPressEvent('Escape', () => closeModal())

  return (
    <Container>
      <InputContainer>
        <SearchInput header />
      </InputContainer>

      <AnimatePresence>
        <SearchContent />
      </AnimatePresence>
    </Container>
  )
}

export const NavbarSearchModal = () => {
  const { isModalOpen, closeModal } = useAlgoliaSearchContext()

  return (
    <AnimatePresence>
      {isModalOpen && (
        <>
          <ShowForDesktop>
            <LayoutGroup>
              <Background
                onClick={closeModal}
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.2, transition: { delay: 0, duration: 0.2 } }}
                exit={{ opacity: 0, transition: { delay: 0, duration: 0.2 } }}
              />
              <Modal
                transition={{ duration: 0.18 }}
                initial={{ opacity: 0, top: -20 }}
                animate={{ opacity: 1, top: 0, transition: { delay: 0, duration: 0.2 } }}
                exit={{ opacity: 0, top: -80, transition: { delay: 0, duration: 0.1 } }}>
                <SearchContentNavbar />
              </Modal>
            </LayoutGroup>
          </ShowForDesktop>

          <ShowForMobile>
            <SearchModalMobile />
          </ShowForMobile>
        </>
      )}
    </AnimatePresence>
  )
}
